// extracted by mini-css-extract-plugin
export default {"row":"style_row__rRAJJ","col__left":"style_col__left__IbbV5","col__right":"style_col__right__x+2Pk","img":"style_img__hGNrV"};